<template>
  <ui-confirmation-modal visible>
    <template #title>
      Cannot upload image
    </template>

    <template #body>
      <div class="text-center">
        There might have been a network issue. Please try again!
      </div>
    </template>

    <template #footer>
      <ui-button variant="primary" @click="$emit('handleOkButtonClick')">
        OK
      </ui-button>
    </template>
  </ui-confirmation-modal>
</template>

<script>
import ConfirmationModal from '@/components/UI/modals/ConfirmationModal.vue'
import Button from '@/components/UI/Button.vue'

export default {
  components: {
    UiButton: Button,
    UiConfirmationModal: ConfirmationModal,
  },
}
</script>
